/**
 * Lazy-load Leaflet on demand so index.html isn't render-blocked by ~47 KiB
 * of third-party JS/CSS that's only needed on the Map tab. Returns a promise
 * that resolves once `window.L` is available. Safe to call multiple times.
 */
let _promise = null;

export function loadLeaflet() {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (window.L) return Promise.resolve(window.L);
  if (_promise) return _promise;

  _promise = new Promise((resolve, reject) => {
    const CSS_HREF = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    const JS_SRC = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

    // CSS — non-blocking (already downloaded but we don't wait on it for JS)
    if (!document.querySelector(`link[href="${CSS_HREF}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = CSS_HREF;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    }

    // JS
    const existing = document.querySelector(`script[src="${JS_SRC}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve(window.L), { once: true });
      existing.addEventListener('error', reject, { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = JS_SRC;
    script.crossOrigin = 'anonymous';
    script.async = true;
    script.onload = () => resolve(window.L);
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return _promise;
}
